// extracted by mini-css-extract-plugin
module.exports = {"boxStyle":"Terms_boxStyle__2bxD5","textStyle":"Terms_textStyle__2GwQV","text":"Terms_text__3m0PG"};